export type TipoContaFinanceiraApi =
  | "BANCO"
  | "CAIXA"
  | "GATEWAY"
  | "OPERACIONAL";

export const CODIGO_CONTA_GATEWAY_EFI = "GATEWAY_EFI";
export const CODIGO_CONTA_CAIXA = "CAIXA_FISICO";

export type ContaFinanceiraGerencialApi = {
  id: string;
  nome: string;
  tipo: TipoContaFinanceiraApi;
  tipoLabel: string;
  ativo: boolean;
  ehPadrao: boolean;
  ehContaRepasse?: boolean;
  saldoInicial: number;
  saldoAtual: number;
  receitasMes: number;
  taxasMes: number;
  despesasMes: number;
  liquidoMes: number;
  codigoInterno: string | null;
  createdAt: string;
  podeExcluir: boolean;
  saldoEfiDisponivel?: number | null;
  saldoEfiBloqueio?: number | null;
  saldoEfiDivergencia?: number | null;
  saldoEfiConsultadoEm?: string | null;
  saldoEfiErro?: string | null;
};

export type ContasFinanceirasGerencialApi = {
  saldoConsolidado: number;
  saldoConsolidadoExtrato: number;
  saldoDisponivelEfi?: number | null;
  saldoCaixaBancos?: number;
  efiSandbox?: boolean;
  quantidadeAtivas: number;
  quantidadeTotal: number;
  contas: ContaFinanceiraGerencialApi[];
  conciliacaoEfi?: ConciliacaoSaldoEfiApi | null;
};

export type ConciliacaoSaldoEfiApi = {
  aplicada: boolean;
  tipo?: "ENTRADA" | "SAIDA";
  valor?: number;
  saldoExtratoAntes?: number;
  saldoExtratoDepois?: number;
  saldoEfiAlvo?: number;
  saldoAlvo?: number;
  movimentacaoId?: string;
  motivo?: string;
};

export type ConciliarSaldoContaFormPayload = {
  saldoReal: string;
  observacao: string;
};

export function isContaGatewayEfi(conta: ContaFinanceiraGerencialApi): boolean {
  return conta.codigoInterno === CODIGO_CONTA_GATEWAY_EFI;
}

export function isContaCaixaPadrao(conta: ContaFinanceiraGerencialApi): boolean {
  return conta.codigoInterno === CODIGO_CONTA_CAIXA;
}

/** Destino de repasse manual (Efí → banco/caixa), exibido ao lado da Efí. */
export function isContaRepasse(conta: ContaFinanceiraGerencialApi): boolean {
  if (isContaGatewayEfi(conta)) return false;
  if (conta.ehContaRepasse) return true;
  return isContaCaixaPadrao(conta);
}

export function ordenarContasRepasse(
  contas: ContaFinanceiraGerencialApi[],
): ContaFinanceiraGerencialApi[] {
  return [...contas].sort((a, b) => {
    if (isContaCaixaPadrao(a) && !isContaCaixaPadrao(b)) return -1;
    if (!isContaCaixaPadrao(a) && isContaCaixaPadrao(b)) return 1;
    if (a.ehPadrao && !b.ehPadrao) return -1;
    if (!a.ehPadrao && b.ehPadrao) return 1;
    return a.nome.localeCompare(b.nome, "pt-BR");
  });
}

export function contaRepassePadrao(
  contas: ContaFinanceiraGerencialApi[],
): ContaFinanceiraGerencialApi | undefined {
  const repasses = ordenarContasRepasse(
    contas.filter((c) => c.ativo && isContaRepasse(c)),
  );
  return repasses[0];
}

export function saldoOperacionalConta(conta: ContaFinanceiraGerencialApi): number {
  if (
    isContaGatewayEfi(conta) &&
    conta.saldoEfiDisponivel != null &&
    Number.isFinite(conta.saldoEfiDisponivel)
  ) {
    return conta.saldoEfiDisponivel;
  }
  return conta.saldoAtual;
}

export type ContaFinanceiraFormPayload = {
  nome: string;
  tipo: TipoContaFinanceiraApi;
  saldoInicial: string;
  ehPadrao: boolean;
  ehContaRepasse: boolean;
};

export type TransferenciaContaFinanceiraFormPayload = {
  contaDestinoId: string;
  valor: string;
  observacao: string;
};
